import React, { useState, useEffect, useContext } from 'react';
import { ApiContext } from '../App';

const Profile = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [editData, setEditData] = useState({});
  const [saveSuccess, setSaveSuccess] = useState(false);
  const { authToken, setUser: setGlobalUser } = useContext(ApiContext);
  
  // API base URL
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8787';

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/auth/profile`, {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          setUser(data.user);
          setEditData({ name: data.user.name });
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false);
      }
    };

    if (authToken) {
      fetchUserProfile();
    }
  }, [authToken]);

  const handleEditToggle = () => {
    if (editing) {
      // Save changes
      handleSave();
    } else {
      setEditing(true);
      setEditData({ name: user?.name || '' });
    }
  };

  const handleSave = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/users/${user.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ name: editData.name })
      });
      
      if (response.ok) {
        const updatedUser = { ...user, name: editData.name };
        setUser(updatedUser);
        setGlobalUser(updatedUser);
        setSaveSuccess(true);
        setEditing(false);
        
        // Reset success message after 3 seconds
        setTimeout(() => setSaveSuccess(false), 3000);
      }
    } catch (error) {
      console.error('Error saving profile:', error);
    }
  };

  const handleChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value
    });
  };

  if (loading) {
    return <div className="loading">Loading profile...</div>;
  }

  return (
    <div className="profile">
      <div className="container">
        <h1>User Profile</h1>
        
        <div className="profile-card">
          <div className="profile-header">
            <h2>{user?.name}</h2>
            <p className="email">{user?.email}</p>
          </div>
          
          <div className="profile-details">
            <div className="detail-group">
              <label>Name:</label>
              {editing ? (
                <input
                  type="text"
                  name="name"
                  value={editData.name}
                  onChange={handleChange}
                />
              ) : (
                <p>{user?.name}</p>
              )}
            </div>
            
            <div className="detail-group">
              <label>Email:</label>
              <p>{user?.email}</p>
            </div>
            
            <div className="detail-group">
              <label>Member Since:</label>
              <p>{user?.created_at ? new Date(user.created_at).toLocaleDateString() : 'N/A'}</p>
            </div>
            
            {user?.subscription && (
              <div className="detail-group">
                <label>Subscription:</label>
                <p className={`subscription-status ${user.subscription.status}`}>
                  {user.subscription.plan_id.charAt(0).toUpperCase() + user.subscription.plan_id.slice(1)} - {user.subscription.status}
                </p>
              </div>
            )}
          </div>
          
          <div className="profile-actions">
            {saveSuccess && <div className="success-message">Profile updated successfully!</div>}
            <button 
              className={`btn ${editing ? 'btn-success' : 'btn-primary'}`}
              onClick={handleEditToggle}
            >
              {editing ? 'Save Changes' : 'Edit Profile'}
            </button>
          </div>
        </div>
        
        <div className="billing-section">
          <h2>Billing Information</h2>
          <div className="subscription-plans">
            <div className="plan">
              <h3>Free Plan</h3>
              <p className="price">$0/month</p>
              <ul>
                <li>5 translations per month</li>
                <li>Basic languages</li>
                <li>Email support</li>
              </ul>
              <button className="btn btn-secondary">Current Plan</button>
            </div>
            <div className="plan">
              <h3>Professional</h3>
              <p className="price">$9.99/month</p>
              <ul>
                <li>Unlimited translations</li>
                <li>All languages</li>
                <li>Priority support</li>
                <li>API access</li>
              </ul>
              <button className="btn btn-primary">Upgrade</button>
            </div>
            <div className="plan">
              <h3>Enterprise</h3>
              <p className="price">$29.99/month</p>
              <ul>
                <li>Unlimited translations</li>
                <li>All languages</li>
                <li>24/7 phone support</li>
                <li>Custom models</li>
                <li>Dedicated account manager</li>
              </ul>
              <button className="btn btn-primary">Upgrade</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;